export namespace MarkdownSyntax {
    export const Mention: string = "@";
    export const LinkWIT: string = "#";
    export const LinkPR: string = "!";
}

export const AllowedAttachmentExtensions = [".PNG", ".GIF", ".JPG", ".JPEG", ".DOCX", ".PPTX", ".XLSX", ".TXT", ".PDF", ".ZIP", ".GZ", ".LYR", ".MOV", ".MP4", ".ICO", ".CSV"];
